import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    text: '',
    button:
      'text-primary trading-[0.06] h-fit border-transparent bg-transparent p-0 text-xs leading-[120%] font-semibold text-black uppercase hover:border-transparent hover:bg-transparent'
  },
  variants: {},
  defaultVariants: {}
});
